<template>
  <div class="partners">
    <header class="text-block">
      <h1>{{ section.title }}</h1>
      <p>{{ section.description }}</p>
    </header>
    <section class="text-block category-links">
      <div
        v-for="category in section.categories"
        v-bind:key="category.alias"
        class="category-link"
      >
        <router-link
          v-bind:to="`${alias}/${category.alias}`"
        >
          <h2>
            <font-awesome-icon
              class="icon"
              v-bind:icon="categoryIcons[category.alias]"
              v-if="categoryIcons[category.alias]"
            ></font-awesome-icon>
            <span>{{ category.short_name }}</span>
          </h2>
          <p>{{ category.description }}</p>
        </router-link>
      </div>
    </section>
    <section class="text-block">
      <p>
        Мы стремимся поддерживать ювелиров в их работе, предоставляя
        эффективные инструменты, которые помогают создавать великолепные
        украшения с минимальными затратами времени и усилий. Присоединяйтесь
        к нам и откройте новые горизонты в мире ювелирного искусства!
      </p>
    </section>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faRing, faLink } from '@fortawesome/free-solid-svg-icons'
import utils from './utils'

export default {
  name: 'ToJewelersPage',
  components: { FontAwesomeIcon },
  data () {
    return {
      section: {
        categories: []
      },
      categoryIcons: {
        'ringcalculator': faRing,
        'chaincalculator': faLink
      },
      title: 'Ювелирам',
      alias: 'tojewelers'
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: utils.getDefaultMetaTags({
        description: this.section.meta_description,
        path: this.$router.resolve(this.$route).href,
        title: this.title
      })
    }
  },
  mounted () {
    this.getSection()
  },
  updated () {
    if (Object.keys(this.section).length > 0 &&
        window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  methods: {
    getSection: function () {
      const apiHost = process.env.API_HOST
      this.$http
        .get(`${apiHost}/api/v1/site-structure/get-section-with-categories/${this.alias}`)
        .then(response => { this.section = response.body })
    }
  }
}
</script>

<style scoped lang="scss">
  .partners {
    @include page-block-vertical-padding();

    & > .text-block {
      @include text-block();
      margin-bottom: 2em;
      &:last-child { margin-bottom: 0; }
    }
    & > .category-links {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 0;

      & > .category-link {
        @include media(">tablet") {
          flex-basis: 46%;  // 100% / 2 - 2 * padding
          padding: 0 2%;
        };
        @include media("<=tablet") {
          flex-basis: 100%;
        };
        @media only print {
          display: block;
          page-break-inside: avoid;
          margin-bottom: 1cm;
          &:last-child { margin-bottom: 0; }
        }
        & > a {
          display: block;
          font-size: 1.5em;
          text-decoration: none;
          & >>> h2 {
            @include framed-color-reversible-button();
            font-family: "Cormorant Light", $font-stack;
            font-size: 1em;
            text-transform: uppercase;
            letter-spacing: 0.2em;
            font-weight: normal;
            margin-bottom: 0.5em;
            color: inherit;
            & > .icon {
              margin-right: 0.25em;
            }
          }
          & >>> p {
            font-family: "Baskerville Italic", $font-stack;
            color: $default-heading-color;
            line-height: 1;
            transition: color 0.5s ease;
            &:hover { color: $default-link-color; }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ToJewelersPage.vue